import {inject, Injectable, OnDestroy} from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateFn} from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { TabStateService } from '@shared//services/tab-state.service';

@Injectable({
  providedIn: 'root'
})
class PermissionsService implements OnDestroy {

    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private tabService = inject(TabStateService);

    private navSubscription: Subscription | null = null;

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.navSubscription) return true;

    this.navSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      switchMap(route => route.data)
    )
    .subscribe(data => {
      this.handleNavigation(data);
    });
    return true;
  }

  ngOnDestroy(): void {
    this.navSubscription?.unsubscribe();
  }

  private handleNavigation(routeData: any): void {
    // Solo procesar si la ruta tiene openTab: true
    if (routeData?.openTab === true) {
      const currentUrl = this.router.url;

      // Obtener información del tab
      const title = routeData.breadcrumb || routeData.title || 'Sin título';
      const icon = routeData.icon || 'pi pi-file';


      // Abrir tab usando el servicio (se guarda la clave i18n para que el pipe translate la reactive al cambiar idioma)
      this.tabService.openTab({
        route: currentUrl,
        title: title,
        icon: icon,
        closable: true
      });
    }
  }


}

export const TabsGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
